import { z } from 'zod'

export const indeedFlexOtpSchema = z.object({
  code: z.string().trim().min(1, 'Email code is required'),
})

export type IndeedFlexOtpFormValues = z.infer<typeof indeedFlexOtpSchema>
